import {
	PerilCharacteristics,
	PerilCreateRequest,
	PerilUpdateRequest,
} from '../../../types/policy';
import {
	PERIL_FIELD_NAMES,
	PERIL_FIELD_UPDATE_VALUES,
	PERIL_FIELD_VALUES,
} from '../data/constants';
import { DefaultValuesType } from '../types';

const getDefaultPerilValues = (
	peril: PerilCharacteristics | PerilUpdateRequest | PerilCreateRequest,
) => {
	const {
		indemnityInAggregate,
		indemnityPerEvent,
		indemnityPerItem,
		lumpSumPayment,
		deductible,
	} = peril;
	const values = {
		[PERIL_FIELD_NAMES.indemnityPerItemType]: indemnityPerItem
			? indemnityPerItem === PERIL_FIELD_UPDATE_VALUES.unlimited
				? [PERIL_FIELD_VALUES.unlimited]
				: [PERIL_FIELD_VALUES.limited]
			: [PERIL_FIELD_VALUES.unset],
		[PERIL_FIELD_NAMES.indemnityPerItem]: indemnityPerItem
			? [indemnityPerItem]
			: [''],
		[PERIL_FIELD_NAMES.indemnityPerEventType]: indemnityPerEvent
			? indemnityPerEvent === PERIL_FIELD_UPDATE_VALUES.unlimited
				? [PERIL_FIELD_VALUES.unlimited]
				: [PERIL_FIELD_VALUES.limited]
			: [PERIL_FIELD_VALUES.unset],
		[PERIL_FIELD_NAMES.indemnityPerEvent]: indemnityPerEvent
			? [indemnityPerEvent]
			: [''],
		[PERIL_FIELD_NAMES.indemnityPerAggregateType]: indemnityInAggregate
			? indemnityInAggregate === PERIL_FIELD_UPDATE_VALUES.unlimited
				? [PERIL_FIELD_VALUES.unlimited]
				: [PERIL_FIELD_VALUES.limited]
			: [PERIL_FIELD_VALUES.unset],
		[PERIL_FIELD_NAMES.indemnityPerAggregate]: indemnityInAggregate
			? [indemnityInAggregate]
			: [''],
		[PERIL_FIELD_NAMES.lumpSumPaymentType]: lumpSumPayment
			? [PERIL_FIELD_VALUES.set]
			: [PERIL_FIELD_VALUES.unset],
		[PERIL_FIELD_NAMES.lumpSumPayment]: lumpSumPayment
			? [lumpSumPayment]
			: [''],
		[PERIL_FIELD_NAMES.deductibleType]: deductible
			? [PERIL_FIELD_VALUES.set]
			: [PERIL_FIELD_VALUES.unset],
		[PERIL_FIELD_NAMES.deductible]: deductible ? [deductible] : [''],
	} as DefaultValuesType;

	return values;
};

export default getDefaultPerilValues;
